export const ASSETS = {
  nick: "https://static.prod-images.emergentagent.com/jobs/6b08dc33-b6d8-4ac9-899d-b2a4795c5d75/images/6e67d100cdfef75a7a5865323e30885e21c660a1ecaf8568f15ac74e0c5b9fb9.jpeg",
  caravan: "https://customer-assets-rejwkqb3.emergentagent.net/job_otm-tech-expert/artifacts/oa2q1faq_OTM%20Van%20Image.webp",
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_otm-tech-expert/artifacts/yw3t42mi_OTM%20Logo.png",
  backdrop: "https://customer-assets-rejwkqb3.emergentagent.net/job_otm-tech-expert/artifacts/1f4brcfm_OTM%20Backdrop.jpeg",
  adminBackdrop: "https://customer-assets-rejwkqb3.emergentagent.net/job_otm-tech-expert/artifacts/58ed424d51d595af_images.jpeg",
};
